import { environment } from 'projects/sharing/environments/environment';

export class API {
  // BASE_URL
  public static readonly BASE_URL = environment.API_BASE_URL;
  public static readonly AUTH_BASE_URL = environment.API_AUTH_BASE_URL;
  public static readonly EMAIL_BASE_URL = environment.API_EMAIL_BASE_URL;
  public static readonly EXTERNAL_BASE_URL = environment.API_EXTERNAL_BASE_URL;
  public static readonly TRANSACTION_BASE_URL =
    environment.API_TRANSACTION_BASE_URL;
  public static readonly SETTLEMENT_BASE_URL =
    environment.API_SETTLEMENT_BASE_URL;
  public static readonly PAYMENT_SIMULATOR_BASE_URL =
    environment.API_PAYMENT_SIMULATOR_BASE_URL;
  public static readonly PAYMENT_LINK_BASE_URL =
    environment.API_PAYMENT_LINK_BASE_URL;
  public static readonly MERCHANT_BASE_URL = environment.API_MERCHANT_BASE_URL;
  public static readonly FILE_BASE_URL = environment.API_FILE_BASE_URL;
  public static readonly PRODUCT_BASE_URL = environment.API_PRODUCT_BASE_URL;
  public static readonly ROLE_BASE_URL = environment.API_ROLE_BASE_URL;
  public static readonly MENU_BASE_URL = environment.API_MENU_BASE_URL;
  public static readonly NOTIFICATION_BASE_URL =
    environment.API_NOTIFICATION_BASE_URL;
  public static readonly NOTIFICATION_SSE_BASE_URL =
    environment.API_NOTIFICATION_SSE_BASE_URL;

  // auth
  public static readonly LOGIN = '/auth/auths/login';
  public static readonly LOGIN_MFA = '/auth/auths/login/mfa';
  public static readonly REGISTER = '/user/users/regist';
  public static readonly CHECK = '/user/users/check';
  public static readonly RESET_PASSWORD = '/user/users/password/forgot';
  public static readonly RESET_PASSWORD_90_DAYS = '/user/users/password/renew';
  public static readonly USERS_LOGOUT = '/auth/auths/logout';

  // email
  public static readonly SEND_EMAIL = '/email/emails/send';

  // transaction
  public static readonly TRANSACTION_SUMMARY =
    '/transaction/transactions/summary';
  public static readonly TRANSACTION_SUMMARY_PERIOD =
    '/transaction/transactions/summary-period';
  public static readonly TRANSACTION_PAYMENT_TREND =
    '/transaction/transactions/payment-trend';
  public static readonly TRANSACTION_TOP_FIVE =
    '/transaction/transactions/top-five';
  public static readonly TRANSACTION_PAYOUT_BALANCE =
    '/transaction/payouts/payout-balance';
  public static readonly TRANSACTION_HISTORY_LIST = '/transaction/transactions';
  public static readonly TRANSACTION_HISTORY_DETAIL =
    '/transaction/transactions/detail';
  public static readonly TRANSACTION_CARD_HISTORY_LIST =
    '/transaction/transactions/card-list';
  public static readonly TRANSACTION_CARD_TRANS_DETAIL =
    '/transaction/transactions/card-detail';
  public static readonly TRANSACTION_CANCEL_HISTORY =
    '/transaction/transactions/cancel-list';
  public static readonly TRANSACTION_CARD_CANCEL_HISTORY =
    '/transaction/transactions/card-cancel-list';
  public static readonly TRANSACTION_CANCEL =
    '/transaction/transactions/cancel';
  public static readonly TRANSACTION_EXPORT =
    '/transaction/transactions/export';
  public static readonly TRANSACTION_CAPTURE =
    '/transaction/transactions/capture';
  public static readonly TRANSACTION_CONFIRM_RECEIPT =
    '/transaction/transactions/akulaku/confirm';

  // payment link
  public static readonly PAYMENT_LINKS = '/payment/links';
  public static readonly PAYMENT_LINKS_EXPORT = '/payment/links/export';
  public static readonly PAYMENT_LINKS_CREATE = '/payment/links/create';
  public static readonly PAYMENT_LINKS_DETAIL = '/payment/links/detail';
  public static readonly PAYMENT_LINKS_UPDATE = '/payment/links/update';

  // payout disbursement
  public static readonly DISBURSEMENT_LIST = '/transaction/payouts';
  public static readonly DISBURSEMENT_DETAIL = '/transaction/payouts/detail';
  public static readonly DISBURSEMENT_EXPORT = '/transaction/payouts/export';

  //settlement
  public static readonly SETTLEMENT = '/settlement/settlements';
  public static readonly SETTLEMENT_SUMMARY = '/settlement/settlements/summary';
  public static readonly SETTLEMENT_SUMMARY_PERIOD =
    '/settlement/settlements/summary-period';

  //payment-simulator
  public static readonly PAYMENT_SIMULATOR_INQUIRY = '/payment/vaccts/inquiry';
  public static readonly PAYMENT_SIMULATOR_PAYMENT = '/payment/vaccts/deposit';
  public static readonly PAYMENT_SIMULATOR_REVERSAL =
    '/payment/vaccts/reversal';
  public static readonly PAYMENT_SIMULATOR_INQUIRY_EWALLET =
    '/payment/ewallet/inquiry';
  public static readonly PAYMENT_SIMULATOR_PAYMENT_EWALLET =
    '/payment/ewallet/payment';
  public static readonly PAYMENT_SIMULATOR_INQUIRY_PAYLOAN =
    '/payment/payloan/inquiry';
  public static readonly PAYMENT_SIMULATOR_PAYMENT_PAYLOAN =
    '/payment/payloan/payment';
  public static readonly PAYMENT_SIMULATOR_INQUIRY_DIRECTDEBIT =
    '/payment/direct-debit/inquiry';
  public static readonly PAYMENT_SIMULATOR_PAYMENT_DIRECTDEBIT =
    '/payment/direct-debit/payment';
  public static readonly PAYMENT_SIMULATOR_QRIS_INQUIRY =
    '/payment/qris/inquiry';
  public static readonly PAYMENT_SIMULATOR_QRIS_PAYMENT =
    '/payment/qris/payment';

  //CVS
  public static readonly PAYMENT_SIMULATOR__CVS_INQUIRY =
    '/payment/cvs/inquiry';
  public static readonly PAYMENT_SIMULATOR__CVS_PAYMENT =
    '/payment/cvs/deposit';
  public static readonly PAYMENT_SIMULATOR_CVS_COMMIT = '/payment/cvs/commit';

  // merchant
  public static readonly MERCHANT_ACTIVATION = '/merchant/merchants/activation';
  public static readonly MERCHANT_BUSINESS_ADD =
    '/merchant/merchants/ims/business/add';
  public static readonly MERCHANT_DRAFT_DELETE =
    '/merchant/merchants/draft/delete';
  public static readonly MERCHANT_DETAIL =
    '/merchant/merchants/activation/detail';
  public static readonly MERCHANT_STATUS_ACTIVATION =
    '/merchant/merchants/activation/status';
  public static readonly MERCHANT_EDIT =
    '/merchant/merchants/activation/resubmit';
  public static readonly MERCHANT_DETAIL_EDIT = '/merchant/merchants/edit';
  public static readonly MERCHANT_GET = '/merchant/merchants';
  public static readonly MERCHANT_APPROVAL = '/merchant/merchants/approval';
  public static readonly MERCHANT_APPROVAL_HISTORY =
    '/merchant/merchants/approval/history';
  public static readonly MERCHANT_GROUP_GET = '/merchant/merchants/groups';

  // upload file
  public static readonly FILE_DETAIL = '/file/files/';
  public static readonly FILE_UPLOAD = '/file/files/upload';
  public static readonly FILE_LIST = '/file/files';

  // upload user
  public static readonly UPLOAD_USER = '/user/users';

  // product
  public static readonly PRODUCT_LIST_ACTIVATION = '/product/products';
  public static readonly PRODUCT_MANAGEMENT_CREATE = '/product/products/create';
  public static readonly PRODUCT_MANAGEMENT_DETAIL = '/product/products/detail';
  public static readonly PRODUCT_MANAGEMENT_UPDATE = '/product/products/update';
  public static readonly PRODUCT_ACTIVATE = '/product/activations/submit';
  public static readonly PRODUCT_ACTIVATE_LIST = '/product/activations';
  public static readonly PRODUCT_ACTIVATE_DETAIL =
    '/product/activations/detail';
  public static readonly PRODUCT_ACTIVATE_APPROVAL =
    '/product/activations/review';
  public static readonly PRODUCT_APPROVAL_HISTORY =
    '/product/activations/history';
  public static readonly PRODUCT_EDIT_PKS = '/product/activations/edit/pks';

  // user settings
  public static readonly USER_SETTINGS_GET_LOGIN_SESSIONS = '/user/users/log';
  public static readonly USER_CHANGE_LOGS = '/user/users/log/change';
  public static readonly USER_ACTIVITY_LOGS_DETAIL = '/user/users/log/detail';
  public static readonly USER_ACTIVITY_LOGS_EXPORT = '/user/users/log/export';
  public static readonly USER_SETTINGS_GET_USER_PROFILE = '/user/users/profile';
  public static readonly USER_SETTINGS_UPDATE_PROFILE_DETAILS =
    '/user/users/update';
  public static readonly USER_SETTINGS_LOGOUT_BY_IDS =
    '/auth/auths/logout/others';
  public static readonly USER_SETTINGS_SEND_OTP = '/auth/auths/otp/send';
  public static readonly USER_SETTINGS_VERIFY_OTP = '/auth/auths/otp/verify';
  public static readonly USER_SETTINGS_CHANGE_EMAIL =
    '/user/users/email/change';
  public static readonly USER_SETTINGS_MFA_VERIFY = '/auth/auths/mfa/verify';
  public static readonly USER_SETTINGS_CHANGE_PASSWORD =
    '/user/users/password/change';

  // Role Management
  public static readonly ROLE_MANAGEMENT_GET_ROLE_LIST = '/role/roles';
  public static readonly ROLE_LIST = '/role/roles';
  public static readonly ROLE_DETAIL = '/role/roles/detail';
  public static readonly ROLE_RESUME = '/role/roles/resume';
  public static readonly ROLE_REMOVE = '/role/roles/delete';

  // nicepay member
  public static readonly MEMBER_LIST = '/user/users/list';
  public static readonly MEMBER_ADD = '/user/users/invite';
  public static readonly MEMBER_REGISTER = '/user/users/regist-account';
  public static readonly MEMBER_INVITE_CHECK = '/user/users/invite/check';
  public static readonly MEMBER_INVITE_RESEND = '/user/users/invite/resend';
  public static readonly MEMBER_GET_USER_PROFILE =
    '/user/users/invite/regist/profile';

  // menu
  public static readonly MENU_LIST = '/menu/menus';
  public static readonly MENU_SET_ROLE_ACTION = '/menu/menus/set-role-action';
  public static readonly MENU_LIST_SIDEBAR = '/menu/menus/nav-bar';

  // notification
  public static readonly NOTIFICATION_PREFERENCE_LIST =
    '/notification/notifications/preferences';
  public static readonly NOTIFICATION_CATEGORY_LIST =
    '/notification/notifications/categories';
  public static readonly NOTIFICATION_PREFERENCE_UPDATE =
    '/notification/notifications/preferences/update';
  public static readonly NOTIFICATION_DISPLAY =
    '/notification/notifications/display';
  public static readonly NOTIFICATION_DISPLAY_SEEN =
    '/notification/notifications/display/seen';

  public static readonly NOTIFICATION_HISTORY =
    '/notification/notifications/dashboard/histories';
  public static readonly NOTIFICATION_HISTORY_READ =
    '/notification/notifications/dashboard/histories/read';
  public static readonly NOTIFICATION_HISTORY_READ_ALL =
    '/notification/notifications/dashboard/histories/read/all';
  public static readonly NOTIFICATION_SSE_STREAM =
    '/que-notification/notifications/push/stream';
}
